import { render, staticRenderFns } from "./staffwithdrawal.vue?vue&type=template&id=ca5491d6&scoped=true"
import script from "./staffwithdrawal.vue?vue&type=script&lang=js"
export * from "./staffwithdrawal.vue?vue&type=script&lang=js"
import style0 from "./staffwithdrawal.vue?vue&type=style&index=0&id=ca5491d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5491d6",
  null
  
)

export default component.exports